import { h, Fragment } from 'preact';
// import { formatMoney } from 'utils/storefront/format-resource';
import FormatMoney from './format-money';

const CartProductPrice = ({ line }) => {
  const getSalePrice = () => {
    if (
      line.properties?._compare_price &&
      parseFloat(line.properties._compare_price)
    ) {
      return line.properties._compare_price;
    }
    if (line.discounted_price !== line.price) return line.original_price / 100;
    return false;
  };


  const salePrice = getSalePrice();
  const regularPrice = (line.line_price / line.quantity) / 100;

  return (
    <>
      {/* Marked down price (Compare-at price in use) */}
      <span className={`${salePrice ? 'text-red' : ''}`}>
        {FormatMoney({
          amount: regularPrice,
          currencyCode: window.TMW?.localization?.currencyCode,
          salePrice: true
        })}
      </span>

      {/* Compare price */}
      {!!salePrice && (
        <s className="block leading-none text-grey-2">
          {FormatMoney({
            amount: salePrice,
            currencyCode: window.TMW?.localization?.currencyCode,
          })}
        </s>
      )}
    </>
  );
};
export default CartProductPrice;
